const readBlobAsDataUrl = (blob: Blob): Promise<string> => {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.onload = () => {
			resolve(String(reader.result));
		};
		reader.onerror = () => {
			reject(reader.error);
		};
		reader.readAsDataURL(blob);
	});
};

export default readBlobAsDataUrl;
